import { Stack } from '@mui/material';

import { Loader } from '@/components/progress/Loader/Loader';

export function ReviewSuggestionLoadingState() {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      height="100%"
      minHeight={400}
    >
      <Loader circularProgressProps={{ size: 40 }} />
    </Stack>
  );
}
